
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRepairLaborGrid extends Serenity.EntityGrid<ECommRepairLaborRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommRepairLabor'; }
        protected getIdProperty() { return ECommRepairLaborRow.idProperty; }
        protected getInsertPermission() { return ECommRepairLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommRepairLaborRow.localTextPrefix; }
        protected getService() { return ECommRepairLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}